var $4d5c142cc5703c47$exports = {};
$4d5c142cc5703c47$exports = {
    "maximum": `\u{5DE}\u{5E7}\u{5E1}\u{5D9}\u{5DE}\u{5D5}\u{5DD}`,
    "minimum": `\u{5DE}\u{5D9}\u{5E0}\u{5D9}\u{5DE}\u{5D5}\u{5DD}`
};


export {$4d5c142cc5703c47$exports as default};
//# sourceMappingURL=he-IL.module.js.map
